export default __webpack_public_path__ + "static/media/loading.ee4bc345.gif";